import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserModel} from '../../../models/User';
import {MixpanelService} from '../../../services/mixpanel.service';
import {CheckoutModalComponent} from '../../checkout/checkout.component';
import {AuthService} from '../../../services/auth.service';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {Tiers} from '../../../models/SubscriptionsModels';
import {PartnerService} from '../../../services/partner.service';
import {Partners} from '../../../models/PartnersModel';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

export enum TierUpgradeMode {
    freeToPremiumPlus = 'freeToPremiumPlus',
    premiumToPremiumPlus = 'premiumToPremiumPlus',
    moreAirports = 'moreAirports',
    moreDestinations = 'moreDestinations'
}

interface ModalContent {
    title:      string;
    imageSrc:   string;
    message:    string;
    buttonText: string;
}
@Component({
    selector: 'app-unlock-deal-modal',
    templateUrl: './unlock-deal-modal.component.html',
    styleUrls: ['./unlock-deal-modal.component.css']
})
export class UnlockDealModalComponent implements OnInit{
    user: UserModel;
    @Input() isVisible = false;
    @Output() close  = new EventEmitter<void>();
    @Output() action = new EventEmitter<void>();
    @Input() mode: TierUpgradeMode = TierUpgradeMode.freeToPremiumPlus;
    safeMessage: SafeHtml;
    TierUpgradeMode = TierUpgradeMode;

    partner: Partners

    contents: Record<TierUpgradeMode, ModalContent> = {
        freeToPremiumPlus: {
            title: `Skip the wait, and get instant access with a Premium Plan`,
            imageSrc: 'assets/images/modals/waitlist-upgrade-800.webp',
            message:  `Premium members get every flight deal we find leaving their home airport with a premium plan. Unlock full access and never miss a flight deal.`,
            buttonText: 'Try Premium+'
        },
        premiumToPremiumPlus: {
            title: `Unlock all the deals with a Premium+ Plan`,
            imageSrc: 'assets/images/modals/waitlist-upgrade-800.webp',
            message:  `
    Premium+ members get every fancy deal we find and save thousands on premium economy and business class seats. Unlock full access and never miss a deal.
  `,
            buttonText: 'Try Premium+'
        },
        moreAirports: {
            title: `Set more departure airports with a premium plan`,
            imageSrc: 'assets/images/modals/310-800.webp',
            message:  `
    Set multiple departure airports to find more amazing fares at local airports around you, so the perfect deal never slips by.
  `,
            buttonText: 'Try Premium+'
        },
        moreDestinations: {
            title: `Add more dream destinations with a Premium Plan`,
            imageSrc: 'assets/images/modals/311-800.webp',
            message:  `
    We prioritize finding deals to your dream destinations and also send SMS alerts for these deals, so you never miss your dream deal.
  `,
            buttonText: 'Try Premium+'
        },
    };

    constructor(public dialogService: DialogService, private auth: AuthService,  private mixpanel: MixpanelService, public config: DynamicDialogConfig, public ref: DynamicDialogRef, private partnerService: PartnerService, private sanitizer: DomSanitizer) {}

    ngOnInit(): void {
        this.auth.user$.subscribe(user =>{
            if(this.config.data){
                this.isVisible = this.config.data.isVisible
                this.mode = this.config.data.mode
            }
            if(user){
                this.user = user
                this.mixpanel.identify(user.id.toString());
                this.mixpanel.track('Unlock deal modal opened')
            }
        });
        this.partnerService.setPartnerId(this.user.upgradePartnerName)
        this.partnerService.partnerInfoSubject.subscribe(partner => {
            if (partner) {
                this.partner = partner;
            }
        });
        const message = this.content.message;
        this.safeMessage = this.sanitizer.bypassSecurityTrustHtml(message)
    }
    get content(): ModalContent {
        return this.contents[this.mode];
    }
    onAction() {
        this.ref.close();
        // Close parent modal if provided
        if (this.config.data?.parentRef) {
            this.config.data.parentRef.close();
        }
        setTimeout(() => {
            this.dialogService.open(CheckoutModalComponent, {
                data: {
                    plan: Tiers.PremiumPlus,
                    partner: this.partner,
                    onboardingRedirect: true,
                    trackingParams: {location: 'Waitlist Modal'},
                    user: this.user
                },
                width: '400px',
                breakpoints: {
                    '500px': '90vw'
                },
                showHeader: false,
                styleClass: 'checkout-dialog p-relative',
                dismissableMask: true,
                appendTo: document.body,
                contentStyle: {
                    borderRadius: '6px',
                    padding: '5px',
                    scrollbarWidth: 'none'
                }
            });

        }, 200)
    }

    onClose() {
        this.ref.close();
        this.close.emit();
    }

    onBackdropClick(e: MouseEvent) {
        if ((e.target as HTMLElement).classList.contains('waitlist-overlay')) {
            this.onClose();
        }
    }

}
